/* eslint-disable */
import moment from 'moment'

const defaultOptions = {
  suffix: true,
}

/**
 * Format dates
 *
 * @param  {string|number|date} date
 * @param  {string} format
 * @return {size}
 */
export const date = (value, format = 'YYYY-MM-DD', { suffix } = defaultOptions) => {
  const time = moment(value)
  switch (format) {
    case 'human':
      return time.fromNow(!suffix)
    case 'days':
      const days = time.diff(new Date(), 'days')
      return `${days} ${days > 1 ? 'days' : 'day'}`
    default:
      return time.format(format)
  }
}
